shadow$provide[522] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, RETURN_ARG:{enumerable:true, get:function() {
  return RETURN_ARG;
}}, SHADOW_ARG:{enumerable:true, get:function() {
  return SHADOW_ARG;
}}});
const SHADOW_ARG = "_i_o";
const RETURN_ARG = "return";

};